import { Grid, styled } from "@mui/material";

export const Container = styled(Grid)({
  height: `calc( 85vh - 200px )`,
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});
